import { getResellersCustomerShiviom } from "../../http/shiviomHttp/ShiviomHttp"
import { useEffect, useState, useCallback, useRef } from "react"
import DomainDetailModal from "./DomainDetailModal"
import Div from "../Div"

export default function ResellerCustomerList({domain_name, ...props}){

    const [customers, setCustomer] = useState([])
    const [domainDetailModal, setDomainDetailModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const observer = useRef()

    const lastCustomerRef = useCallback(node => {
        if (loading) return
        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting ) {
                setPage(prevPage => prevPage + 1)
            }
        })
        if (node) observer.current.observe(node)
    }, [loading])

    const getResellerCustomerShiviom = useCallback(async () => {
   
    const response = await getResellersCustomerShiviom(domain_name, page)
        setLoading(true)
           if (response && response.customers) {  // Check if response and response.customers exist
            setCustomer(prevCustomers => [...prevCustomers, ...response.customers])
        }
        setLoading(false)
          
       }, [domain_name, page])

    useEffect(() => {
        getResellerCustomerShiviom()
    }, [getResellerCustomerShiviom])

    function handleDomainClick(domain){
        setDomainDetailModal(domain)
    }

    return (
        <>
                  <Div {...props} >
                  {domainDetailModal ? <DomainDetailModal domain_name={domainDetailModal} show={true.toString()} open
                 handleClicked={setDomainDetailModal} /> : null}
                  { customers ?  <>
                                    <table className="table" border="1">
                                        <thead>
                                            <tr>
                                                <th>Customer Domain</th>
                                                {/* <th>Customer Name </th>
                                                <th>Reseller Company Name</th>
                                                <th>Reseller Contact Number</th>
                                                <th>Reseller Email Id</th> */}
                                            </tr>
                                        </thead>
                                        <tbody id="tableBody">
                                            {customers.map((customer) =>
                                                <>
                                                    <tr key={customer.cust_id}>
                                                        <td style={{cursor: 'pointer'}} onClick={() => handleDomainClick(customer.domain_name)}>
                                                            {customer.domain_name}
                                                        </td>
                                                        {/* <td>{customer.billing_contact_name}</td>
                                                        <td>{customer.billing_company_name}</td>
                                                        <td>{customer.billing_contact_number}</td> */}
                                                        {/* <td>{customer.licensed_seats}</td> */}
                                                        {/* <td>{customer.reseller_email}</td>            */}
                                                    </tr>
                                                </>
                                               
                                            )

                                            }
                                        </tbody>
                                    </table>
                                      {loading && <p>Loading more customers...</p>}
                                </>
                                : null

                        }
                    </Div>     
        </>
    )
}